const quiz = [
    {
        question: "ความรักของคุณนั้น",
        answers: {
            เรียบง่ายและอธิบายได้ไม่ยาก: ["hub"],
            ยุ่งยากและสับสน: ["sch", "thr"],
            ไม่แน่ใจ: ["sch"],
        },
    },
    {
        question: "ย้อนนึกกลับไปตอนที่ไม่มีใคร<br/>คุณมักจะ",
        answers: {
            จินตนาการว่าจะมีใครซักคนผ่านเข้ามา: ["grv"],
            ยอมรับกับสิ่งที่มันเป็น: ["mas", "new", "img"],
            ไม่แน่ใจ: ["sch"],
        },
    },
    {
        question: "เวลาเสียใจคุณมักจะ",
        answers: {
            ฟังเพลงเศร้าเพื่อให้ตัวเองได้ปลดปล่อย: ["hlf"],
            พยายามหาสิ่งที่ทำแล้วมีความสุข: ["hub", "img"],
            ไม่แน่ใจ: [],
        },
    },
    {
        question: "อารมณ์ร้อนเกิดขึ้นได้เสมอ<br/>และเมื่อเกิดขึ้น คุณมักที่จะ",
        answers: {
            พยายามยับยั้งให้สิ่งเหล่านั้นมันหายไปด้วยตัวเอง: ["grv"],
            บอกเล่าให้คนที่คุณไว้ใจ: ["grv"],
            ไม่ใช่ทั้งคู่: ["sch", "thr"],
        },
    },
    {
        question: "คุณมองว่าความรักเป็น",
        answers: {
            การฝืนธรรมชาติ: ["img"],
            การไหลตามธรรมชาติ: ["hlf"],
            ไม่แน่ใจ: ["sch"],
        },
    },
    {
        question: "คุณและเขา",
        answers: {
            มั่นคง: ["hlf"],
            สับสน: ["sch"],
            ไม่แน่ใจ: ["img"],
        },
    },
    {
        question: "คุณมักจะใช้ช่วงเวลาที่คุณมีความรัก<br/>จมไปกับมันและทำความเข้าใจมัน",
        answers: {
            ใช่: ["scw"],
            ไม่ใช่: ["grv"],
            ไม่แน่ใจ: ["sch"],
        },
    },
    {
        question: "สำหรับคุณความรักคือ",
        answers: {
            ความมั่นคงแข็งแรงและการเดินทาง: ["new"],
            การค้นหาในสิ่งที่ไม่เคยพบเจอ: ["thr"],
            ไม่ใช่ทั้งคู่: ["sch"],
        },
    },
    {
        question: "คุณชอบที่จะ",
        answers: {
            ทำความเข้าใจ: ["new"],
            ปล่อยให้เป็นปริศนา: ["hub"],
            ไม่ใช่ทั้งคู่: ["sch"],
        },
    },
    {
        question: "ในการเดินทางของความรัก<br/>คุณเลือกที่จะ",
        answers: {
            ไปให้สุดทางแล้วค่อยตัดสินใจ: ["sch", "thr"],
            วางแผนอย่างรอบคอบ: ["hlf"],
            ไม่แน่ใจ: ["sch"],
        },
    },
    {
        question: "คำพูดคำจาของคุณมักจะ",
        answers: {
            สะท้อนความเป็นจริง: ["hub"],
            เลือกที่จะพูดสิ่งที่คู่สนทนาอยากฟัง: ["thr"],
            ไม่ใช่ทั้งคู่: ["new"],
        },
    },
    {
        question: "ถ้าคุณเสียใครบางคนไปคุณหวังว่า",
        answers: {
            คุณจะได้เขากลับคืนมาซักวัน: ["grv"],
            เขาจะได้ไปมีชีวิตที่ดี: ["img"],
            "เฉย ๆ": ["thr"],
        },
    },
];
const quizf = [
    {
        question: "ความรักของคุณนั้น",
        answers: {
            เรียบง่ายและอธิบายได้ไม่ยาก: ["hub"],
            ยุ่งยากและสับสน: ["sch", "thr"],
            ไม่แน่ใจ: ["sch"],
        },
    },
];
export { quiz };
